export default "__VITE_ASSET__DFyxOKNM__"